("use strict");
(function () {
  if (!customElements.get("flavours-slider")) {
    class FlavoursSlider extends HTMLElement {
      #swiper = null;
      #resizeObserver = null;
      #debounceTimer = null;
      #currentBreakpointKey = null;

      constructor() {
        super();
        this.slider = null;
        this.pagination = null;
      }

      connectedCallback() {
        this.#setupElements();
        this.#initSwiper();
        this.#observeResize();
      }

      disconnectedCallback() {
        this.#destroySwiper();
        this.#resizeObserver?.disconnect();
        clearTimeout(this.#debounceTimer);
      }

      #setupElements() {
        this.slider = this.querySelector('[data-component="slider"]');
        this.pagination = this.querySelector('[data-component="pagination"]');
      }

      #getBreakpointConfig() {
        const width = window.innerWidth;

        if (width >= 1366) return { key: "1366", slidesPerView: 5 };
        if (width >= 1024) return { key: "1024", slidesPerView: 3 };
        if (width >= 768) return { key: "768", slidesPerView: 2 };
        return { key: "0", slidesPerView: 1 };
      }

      #getSwiperConfig() {
        const hasPagination = Boolean(this.pagination);

        return {
          slidesPerView: 5,
          spaceBetween: 20,
          loop: false,
          // centeredSlides: true,
          initialSlide: 1,
          breakpoints: {
            0: {
              slidesPerView: 1,
              initialSlide: 1,
              ...(hasPagination && {
                pagination: {
                  el: this.pagination,
                  clickable: true,
                },
              }),
            },
            768: {
              slidesPerView: 2,
              initialSlide: 1,
              ...(hasPagination && {
                pagination: {
                  el: this.pagination,
                  clickable: true,
                },
              }),
            },
            1024: {
              slidesPerView: 3,
              initialSlide: 1,
              ...(hasPagination && {
                pagination: {
                  el: this.pagination,
                  clickable: true,
                },
              }),
            },
            1366: {
              slidesPerView: 5,
              initialSlide: 1,
            },
          },
        };
      }

      #initSwiper() {
        if (!this.slider) {
          console.warn("FlavoursSlider: slider element not found.");
          return;
        }

        this.#swiper = new Swiper(this.slider, this.#getSwiperConfig());
        this.#currentBreakpointKey = this.#getBreakpointConfig().key;
      }

      #destroySwiper() {
        if (this.#swiper) {
          this.#swiper.destroy(true, true);
          this.#swiper = null;
        }
      }

      #reinitSwiper() {
        this.#destroySwiper();
        this.#initSwiper();
      }

      #observeResize() {
        // ResizeObserver is preferred over window resize — fires only when
        // the component itself changes size, avoiding unnecessary work.
        this.#resizeObserver = new ResizeObserver(() => {
          clearTimeout(this.#debounceTimer);
          this.#debounceTimer = setTimeout(() => {
            const { key } = this.#getBreakpointConfig();

            // Only reinit when crossing a breakpoint boundary, not on every px change.
            if (key !== this.#currentBreakpointKey) {
              this.#currentBreakpointKey = key;
              this.#reinitSwiper();
            }
          }, 150);
        });

        this.#resizeObserver.observe(this);

        // Orientation change fires on mobile when ResizeObserver may not catch it fast enough.
        screen.orientation?.addEventListener("change", () => {
          clearTimeout(this.#debounceTimer);
          this.#debounceTimer = setTimeout(() => this.#reinitSwiper(), 150);
        });
      }
    }

    customElements.define("flavours-slider", FlavoursSlider);
  }
})();
